import React, { useEffect, useState } from 'react';
import { getChannelInfos } from '../../../services/channel';
import { addDotAfterThreeDigits } from '../../../helpers/utils';
import { Card, CardContent, Typography } from '@material-ui/core';

const ChannelInfos = ({ channelUid }) => {
  const [channelInfos, setChannelInfos] = useState({});
  useEffect(() => {
    getChannelInformation();
  }, []);

  const sectionName = {
    email: 'Email',
    name: 'Name',
    paidSaasStatus: 'Paid Saas Status',
    subscriberActive: 'Subscribers Active',
    subscriberCount: 'Subscribers Count',
    subscriberBlacklisted: 'Subscribers Blacklisted',
    subscriberInactive: 'Subscribers Inactive',
    url: 'URL',
  };

  const getChannelInformation = async () => {
    try {
      const { data } = await getChannelInfos(channelUid);
      setChannelInfos(data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="channel-infos">
      {channelInfos &&
        Object.keys(channelInfos)
          .filter(exception => exception !== 'success')
          .map(key => (
            <Card data-testid="card-metrics" key={key} className="card">
              <CardContent>
                <Typography>{sectionName[key]}</Typography>
                <Typography color={`${key === 'paidSaasStatus' && channelInfos[key] === 'INACTIVE' ? 'error' : 'textSecondary'}`}>
                  {key === 'subscriberActive' || key === 'subscriberBlacklisted' || key === 'subscriberInactive'
                    ? addDotAfterThreeDigits(channelInfos[key])
                    : channelInfos[key]}
                </Typography>
              </CardContent>
            </Card>
          ))}
    </div>
  );
};

export default ChannelInfos;
